import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'underscore'
import Q from '../vendor/q'
import api from '../services/api.js'

Vue.use(Vuex)

const getAcademtData = (first, mappings) => {
	return {
		'id': first.acadid,
		'name': first.acadname,
		'company': first.company,
		'lastrun': first.lastrun,
		'mappings': mappings
	}
}

export default new Vuex.Store({
	state: {
		user: {
			authenticated: false,
			name: null
		},
		academies: [],
		academiesList: [],
		academiesError: '',
		acadimiesUpdated: null,
		academiesLoaded: false,
		// temp holder for raw JSON
		usermappings: {
			data: null,
			pollCount: 0,
			ready: false,
			msg: '',
			details: null
		},
		config: {
			hridSync: true,
			ascSync: false,
			hridPush: false,
			delay: {
				enabled: true,
				days: 1
			},
			ignores: [],
			paytype: {
				hourly: [],
				salary: []
			},
			excludeJobs: []
		},
		status: {
			lastSync: null,
			status: null
		},
		app: {
			title: 'HotSchedules Integration Administration',
			version: '',
			loading: false,
			suppressLoading: false
		},
		sync: {
			syncing: false,
			count: 0,
			error: null

		},
		activity: {
			log: [],
			offset: 0,
			end: false,
			filter: null
		},
		jobswap: {
			list: [],
			ready: false,
			pollCount: 0,
			msg: null
		},
		paytype: {
			list: [],
			ready: false,
			pollCount: 0,
			msg: null
		},
		troubleshooting: {
			searching: false
		},
		hierarchy: {
			store: null,
			err: null
		},
		mapping: {
			step: 0,
			error: null,
			academy: null,
			ecr: null,
			location: null,
			completed: null
		},
		dataError: null
	},
	mutations: {
		// used for testing routes
		log (response) {
			console.log('mutation called with', response.body, response)
		},
		setVersion (state, data) { state.app.version = data.ver },
		setLoggedIn: (state, username) => {
			state.user.authenticated = true
			state.user.name = username
		},
		setLoggedOut: state => { state.user.authenticated = false },
		addAcademy (state, academies) {
			let grouped = _.groupBy(academies, 'acadid')
			// time stamp
			state.academies = academies
			state.academiesLoaded = true
			state.app.loading = false
			state.academiesUpdated = Math.round(new Date().getTime() / 1000)
			state.academiesList = _.reduce(grouped, function (acadList, acad) {
				// get academy name and id from first options
				//
				acadList.push(getAcademtData(acad[0], acad))
				return acadList
			}, [])
		},
		addJobsList (state, response) {
			if (_.isArray(response)) {
				state.jobswap.ready = true
				state.jobswap.list = response
			} else {
				state.jobswap.msg = response.message
				state.jobswap.ready = false
			}
			state.jobswap.pollCount++
		},
		addJobsPayList (state, response) {
			if (_.isArray(response)) {
				state.paytype.ready = true
				state.paytype.list = response
			} else {
				state.paytype.msg = response.message
				state.paytype.ready = false
			}
			state.paytype.pollCount++
		},
		addLogEntries (state, entries) {
			state.app.loading = false
			state.activity.end = !entries.logs.length
			_.each(entries.logs, (row) => { state.activity.log.push(row) })
			state.activity.offset = state.activity.log.length
		},
		setSuppressLoading (state, b) {
			state.app.suppressLoading = b
		},
		syncing (state, action) {
			state.sync.syncing = true
			state.sync.action = action
		},
		syncDone (state, error) {
			state.sync.action = null
			state.sync.error = error
		},
		lookup (state, response) {
			console.log('user lookup returned', response.body)
			state.troubleshooting.searching = false
		},
		setAcademyConfig (state, response) {
			state.config = response
		},
		setUserMappings (state, response) {
			if (!_.isArray(response)) {
				state.usermappings.pollCount++
				state.usermappings.ready = false
				state.usermappings.msg = response.message
			} else {
				state.usermappings.pollCount = 0
				state.usermappings.ready = true
				state.usermappings.data = response
				state.troubleshooting.searching = false
			}
		},
		setUserDetails (state, response) {
			console.log('setUserDetails', response)
			state.usermappings.details = response
		},
		setStatus (state, response) {
			state.status = response
			if (state.status.syncAvailable) {
				state.sync.syncing = false
				state.sync.count = 0
			} else {
				state.sync.count++
			}
		},
		syncStatus (state, response) {
			state.status = response
			if (state.status.syncAvailable) {
				state.sync.syncing = false
				state.sync.count = 0
			} else {
				state.sync.count++
			}
		},
		setAcademyInfo (state, response) {
			if (response && response.acadid) {
				state.mapping.academy = response
				state.mapping.error = null
				state.mapping.step = 1
			} else {
				state.mapping.error = 'Academy not found'
			}
		},
		createNewMapping (state, response) {
			state.mapping.completed = response
			state.mapping.step = 4
		},
		setExtCompRef (state, response) {
			if (_.isString(response)) {
				state.mapping.error = 'could not find root node for extCompRef'
			} else {
				state.mapping.ecr = response
				state.mapping.error = null
				state.mapping.location = response.nodes[0]
				state.mapping.step = 2
			}
		},
		clearMappingError (state) {
			state.mapping.error = null
		},
		setNewMappingStep (state, step) {
			state.mapping.step = step
		},
		setNewMappingLocation (state, loc) {
			state.mapping.location = loc
		},
		clearNewMappingData (state) {
			state.mapping = {
				step: 0,
				error: null,
				academy: null,
				ecr: null,
				location: null,
				completed: null
			}
		},
		removeMapping (state, response) {
			let acad = _.findWhere(state.academiesList, { id: response.acadid })
			if (!acad) return
			let n = _.findIndex(acad.mappings, (m) => m.extCompRef === response.mapping.extCompRef)

			if (n !== -1) {
				acad.mappings.splice(n, 1)
			}
		},
		removeAllMappings (state, response) {
			let acad = _.findWhere(state.academiesList, { id: response.acadid })
			if (acad) {
				acad.mappings = []
			}
		},
		setDataError (state, msg) {
			state.dataError = msg
		},
		clearDataError (state) {
			state.dataError = null
		},
		setHierarchyStore (state, response) {
			console.log('HIERACHY RESPONSE', response)
			state.hierarchy.store = response.store
			state.hierarchy.err = response.err
		}
	},
	actions: {
		setActivityFilter (store, filter) {
			if (store.state.activity.filter !== filter) {
				store.state.activity.offset = 0
				store.state.activity.end = false
				store.state.activity.filter = filter
				store.state.activity.log = []
			}
		},
		getAcademyConfig (store, acadid) {
			return api.getAcademyConfig(acadid)
		},
		// gets
		getAcademies (store, context) {
			store.state.app.loading = true
			return api.getAcadList()
		},
		getAppVersion (store, context) {
			return api.getAppVersion()
		},
		getLogEntries (store, context) {
			if (store.state.activity.end) { return Q() }

			store.state.app.loading = true
			return api.getLogEntries(store.state.activity.offset, store.state.activity.filter)
		},
		getJobsList (store, acadid) {
			if (store.state.jobswap.ready) {
				store.state.jobswap.pollCount = 0
				store.state.jobswap.ready = false
			}
			if (!acadid) {
				return true
			}
			return api.getJobsList(acadid)
		},
		getJobPaytypes (store, acadid) {
			if (store.state.paytype.ready) {
				store.state.paytype.pollCount = 0
				store.state.paytype.ready = false
			}
			if (!acadid) {
				return true
			}
			return api.getJobsPayList(acadid)
		},
		// posts
		userlookup (store, query) {
			store.state.troubleshooting.searching = true
			return api.getUser(query)
		},
		updateJobsList (store, data) {
			return api.setJobMappings(data.id, data.mappings)
		},
		// config settings actions
		setHRIDsync: (store, data) => api.setHRIDsync(data.id, data.action),
		setASCsync: (store, data) => api.setASCsync(data.id, data.action),
		setHRIDpush: (store, data) => api.setHRIDpush(data.id, data.action),
		addIgnores (store, data) {
			let ignores = _._.uniq(data.ignores.concat(store.state.config.ignores))
			return api.updateIgnores(data.id, ignores)
		},
		removeIgnore (store, data) {
			let ignores = _.without(store.state.config.ignores, data.ignore)
			return api.updateIgnores(data.id, ignores)
		},
		setDelayRemoval (store, data) {
			return api.setDelayRemoval(data.id, data.action, data.days)
		},
		updatePayType (store, data) {
			return api.updatePayType(data.id, data.hourly)
		},
		updateExcluded (store, data) {
			return api.updateExcluded(data.id, data.excludeJobs)
		},
		getUserMappings (store, data) {
			if (store.state.usermappings.ready) {
				store.state.usermappings.pollCount = 0
				store.state.usermappings.ready = false
			}
			store.state.troubleshooting.searching = true
			return api.getUserMappings(data.id)
		},
		getUserDetails (store, data) {
			store.state.usermappings.details = null
			return api.getUserDetails(data.acadid, data.schooxid, data.hsids)
		},
		clearUserMappings (store) {
			store.state.usermappings.pollCount = 0
			store.state.usermappings.ready = false
			store.state.usermappings.data = []
			store.state.troubleshooting.searching = false
		},
		clearUserDetails (store) {
			store.state.usermappings.details = null
		},
		clearJobs (store) {
			store.state.paytype.pollCount = 0
			store.state.paytype.ready = false
			store.state.paytype.list = []
			store.state.jobswap.pollCount = 0
			store.state.jobswap.ready = false
			store.state.jobswap.list = []
		},
		getStatus (store, acadid) {
			return api.getStatus(acadid)
		},
		sync (store, acadid) {
			store.state.sync.syncing = true
			store.state.sync.count = 1
			return api.sync(acadid)
		},
		delink (store, data) {
			return api.delink(data.acadid, data.user)
		},
		// new mapping
		acadLookup (store, acadid) {
			store.state.mapping.error = null
			return api.acadLookup(acadid)
		},
		getExtCompRef (store, extCompRef) {
			store.state.mapping.error = null
			return api.getExtCompRef(extCompRef)
		},
		createNewMapping (store, data) {
			return api.createNewMapping(data)
		},
		removeMapping (store, data) {
			return api.removeMapping(data.acadid, data.mapping)
		},
		removeAllMappings (store, data) {
			return api.removeAllMappings(data.acadid)
		},
		getHierarchyStore (store, data) {
			return api.getHierarchyStore(data.extCompRef, data.storeId)
		},
		clearHierarchyStore (store) {
			store.state.hierarchy.stores = null
			store.state.hierarchy.err = null
		}
	}
})



// WEBPACK FOOTER //
// ./src/data/AppData.js